<template>
  <div class="wrapper">
    <Header data-title="에러페이지" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="ac">
            <p class="txtM">
              500 error :(
            </p>
          </div>

          <div class="btnArea sticky">
            <button @click="$router.replace('/')" type="button" class="btn_p">
              홈으로
            </button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
  </div>
  <!-- wrapper(e) -->
</template>
<script>
export default {
  name: 'error500',
  methods: {
    exit() {
      window.exit();
    },
  },
};
</script>
